export default __webpack_public_path__ + "nav_logo.png";